import { makeStyles } from '@material-ui/core';
import { AmbulantIcon, CarrierIcon, StretcherIcon, WheelchairIcon } from '../Icon';
import { classNames } from '../../utils';

const useStyles = makeStyles(() => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.438rem',
  },
  icon: {
    width: '2.142rem',
    height: '2.142rem',
    overflow: 'visible',
  },
  label: {
    color: '#2E4469',
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: '1.25rem',
    whiteSpace: 'nowrap',
  },
}));

const transportModeConfig = {
  WHEELCHAIR: {
    label: 'Wheelchair',
    Icon: WheelchairIcon,
  },
  STRETCHER: {
    label: 'Stretcher',
    Icon: StretcherIcon,
  },
  CARRIER: {
    label: 'Carrier',
    Icon: CarrierIcon,
  },
  AMBULANT: {
    label: 'Ambulant',
    Icon: AmbulantIcon,
  },
};

const TransportMode = ({ type, labelClass }) => {
  const classes = useStyles();
  const transportType = typeof type === 'string' ? type.trim().toUpperCase() : '';
  const mode = transportModeConfig?.[transportType] ?? '';

  // 没有ambStatus的时候
  if (!transportType) {
    return <span className={classNames(classes.label, labelClass)}>--</span>;
  }

  // 有ambStatus，但是status并不是上面四种之一，只show文字
  if (transportType && !mode) {
    return <span className={classNames(classes.label, labelClass)}>{type}</span>;
  }

  const renderIcon = () => {
    const Icon = mode.Icon;
    return <Icon className={classes.icon} />;
  };

  return (
    <span className={classes.root}>
      {renderIcon()}
      <span className={classNames(classes.label, labelClass)}>{mode.label}</span>
    </span>
  );
};

export default TransportMode;
